import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '../environments/environment';
import { LoginService } from '../pages/login/services/login.service';
import { isInternalRedirectPath, isWhitelistedExternalRedirect } from '../utils/redirect-url.util';

@Injectable({ providedIn: 'root' })
export class AlreadyAuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private loginService: LoginService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    // chưa login -> cho vào login page
    if (!this.loginService.hasToken()) {
      return of(true);
    }

    return this.loginService.userInfo().pipe(
      map((res) => {
        if (!res?.success) {
          return true;
        }

        const redirectUrl = route.queryParamMap.get('redirectUrl');

        if (redirectUrl) {
          if (isInternalRedirectPath(redirectUrl)) {
            this.router.navigateByUrl(redirectUrl, { replaceUrl: true });
            return false;
          }
          if (
            isWhitelistedExternalRedirect(redirectUrl, environment.WHITELIST_REDIRECT_URL ?? [])
          ) {
            const token = localStorage.getItem('token');
            const refreshToken = localStorage.getItem('refresh_token');
            const tokenObject = {
              access_token: token,
              refresh_token: refreshToken,
            };
            if (token) {
              document.cookie = `tammiToken=${JSON.stringify(tokenObject)}; path=/; max-age=3600; domain=${environment.DOMAIN_COOKIE}; Secure;`;
            }
            window.location.href = redirectUrl;
            return false;
          }
        }

        // default redirect
        this.router.navigateByUrl('/chat', { replaceUrl: true });
        return false;
      }),
      catchError(() => of(true)),
    );
  }
}
